export const TRANSITION_DURATION = {
	VERY_FAST: 100,
	FAST: 150,
	BASE: 200,
	SLOW: 500,
} as const;

export function delay(ms: number): Promise<void> {
	return new Promise((resolve) => setTimeout(resolve, ms));
}
